module.exports = __webpack_public_path__ + "img/cart.c210499d.svg";